import {NextRouter} from "next/router";

export const appendQuery = (url: string, params: any = {}): string => {
	// using url.searchParams to append query params
	const urlObject = new URL(url);
	Object.keys(params).forEach((key) => {
			urlObject.searchParams.append(key, params[key]);
		}
	);
	return urlObject.toString();
}

export const escapeString = (str: string) => {
	return str.replace(/"/g, '\\"')
		// replace \n with \\n
		.replace(/\n/g, '\\n');
}

export const getUrl = (path: string, router: NextRouter) => {
	const siteUrl = process.env.NEXT_PUBLIC_APP_URL || 'http://localhost';
	const cleanPath = path.split('#')[0].split('?')[0];
	const canonicalUrl = `${siteUrl}${router.defaultLocale != router.locale ? `/${router.locale}` : ''}${(router.asPath === '/' ? '' : cleanPath)}`;
	const fullUrl = `${canonicalUrl}`;

	return fullUrl;
}

export const extractPath = (url: string): string => {
	// if not begin with http or https return the url
	if (!url.startsWith('http'))
	{
		return url;
	}

	// using url.searchParams to append query params
	const urlObject = new URL(url);
	return urlObject.pathname + urlObject.search;
}